import React, { useState } from 'react';
import './StudyGoals.css';

export const StudyGoals = ({
  dailyGoal,
  weeklyGoal,
  dailyProgress,
  weeklyProgress,
  dailyGoalMet,
  weeklyGoalMet,
  dailyProgressPercent,
  weeklyProgressPercent,
  onSetDailyGoal,
  onSetWeeklyGoal
}) => {
  const [isEditingDaily, setIsEditingDaily] = useState(false);
  const [isEditingWeekly, setIsEditingWeekly] = useState(false);
  const [tempDailyGoal, setTempDailyGoal] = useState(dailyGoal);
  const [tempWeeklyGoal, setTempWeeklyGoal] = useState(weeklyGoal);

  const handleSaveDailyGoal = () => {
    if (tempDailyGoal > 0) {
      onSetDailyGoal(tempDailyGoal);
      setIsEditingDaily(false);
    }
  };

  const handleSaveWeeklyGoal = () => {
    if (tempWeeklyGoal > 0) {
      onSetWeeklyGoal(tempWeeklyGoal);
      setIsEditingWeekly(false);
    }
  };

  return (
    <div className="study-goals">
      {/* Daily Goal */}
      <div className="goal-section">
        <div className="goal-header">
          <div className="goal-title">
            <span className="goal-icon">{dailyGoalMet ? '✓' : '📅'}</span>
            <span className="goal-name">Daily Goal</span>
          </div>
          {isEditingDaily ? (
            <div className="goal-edit">
              <input
                type="number"
                className="goal-input"
                value={tempDailyGoal}
                onChange={(e) => setTempDailyGoal(parseInt(e.target.value) || 0)}
                min="1"
                max="999"
              />
              <button className="goal-save-btn" onClick={handleSaveDailyGoal}>
                Save
              </button>
              <button className="goal-cancel-btn" onClick={() => setIsEditingDaily(false)}>
                Cancel
              </button>
            </div>
          ) : (
            <button className="goal-edit-btn" onClick={() => {
              setTempDailyGoal(dailyGoal);
              setIsEditingDaily(true);
            }}>
              Edit
            </button>
          )}
        </div>
        <div className="goal-progress">
          <div className="goal-stats">
            <span className="goal-current">{dailyProgress}</span>
            <span className="goal-separator">/</span>
            <span className="goal-target">{dailyGoal} cards</span>
          </div>
          <div className="progress-bar">
            <div
              className={`progress-fill ${dailyGoalMet ? 'goal-met' : ''}`}
              style={{ width: `${dailyProgressPercent}%` }}
            />
          </div>
          <div className="progress-percent">
            {dailyProgressPercent.toFixed(0)}%
          </div>
        </div>
        {dailyGoalMet && (
          <div className="goal-badge">
            🎉 Daily goal completed!
          </div>
        )}
      </div>

      {/* Weekly Goal */}
      <div className="goal-section">
        <div className="goal-header">
          <div className="goal-title">
            <span className="goal-icon">{weeklyGoalMet ? '✓' : '📊'}</span>
            <span className="goal-name">Weekly Goal</span>
          </div>
          {isEditingWeekly ? (
            <div className="goal-edit">
              <input
                type="number"
                className="goal-input"
                value={tempWeeklyGoal}
                onChange={(e) => setTempWeeklyGoal(parseInt(e.target.value) || 0)}
                min="1"
                max="9999"
              />
              <button className="goal-save-btn" onClick={handleSaveWeeklyGoal}>
                Save
              </button>
              <button className="goal-cancel-btn" onClick={() => setIsEditingWeekly(false)}>
                Cancel
              </button>
            </div>
          ) : (
            <button className="goal-edit-btn" onClick={() => {
              setTempWeeklyGoal(weeklyGoal);
              setIsEditingWeekly(true);
            }}>
              Edit
            </button>
          )}
        </div>
        <div className="goal-progress">
          <div className="goal-stats">
            <span className="goal-current">{weeklyProgress}</span>
            <span className="goal-separator">/</span>
            <span className="goal-target">{weeklyGoal} cards</span>
          </div>
          <div className="progress-bar">
            <div
              className={`progress-fill ${weeklyGoalMet ? 'goal-met' : ''}`}
              style={{ width: `${weeklyProgressPercent}%` }}
            />
          </div>
          <div className="progress-percent">
            {weeklyProgressPercent.toFixed(0)}%
          </div>
        </div>
        {weeklyGoalMet && (
          <div className="goal-badge">
            🎉 Weekly goal completed!
          </div>
        )}
      </div>
    </div>
  );
};
